import { useState } from 'react';
import router, { useRouter } from 'next/router';
import { Modal, message } from 'antd';
import type { ClickRecommendProduct } from '../../product';

const goToProductDetail = (skuSysNo: string, currentProductId: string) => {
  if (currentProductId === skuSysNo) {
    message.info('点击的推荐商品是当前商品');
    return true;
  }
  router.push(`/product/detail?id=${skuSysNo}`);
};

// 处理「推荐商品」点击联动场景
export default function useRecommendProductClick({
  onRecommendConfirm,
}: {
  onRecommendConfirm: () => void;
}) {
  const [currentSelectedRecommendProduct, setCurrentSelectedRecommendProduct] =
    useState<ClickRecommendProduct | null>(null);
  const { query } = useRouter();
  const { id: currentProductId } = query;
  const onRecommendProductClick = (product: ClickRecommendProduct) => {
    // NOTE: 推荐商品编码是使用 「bestSkuSysNo」 还是
    const { concreteFlag, bestSkuSysNo } = product;
    // 「混凝土」商品，直接跳转详情页
    if (concreteFlag) {
      goToProductDetail(bestSkuSysNo, currentProductId as string);
    } else {
      // 弹窗让用户选择去向
      Modal.confirm({
        title: '温馨提示',
        content: '您可以选择查看商品详情页或直接前往推荐清单',
        okText: '前往推荐清单',
        cancelText: '查看商品详情',
        closable: true,
        onOk() {
          setCurrentSelectedRecommendProduct(product);
          onRecommendConfirm();
        },
        onCancel(closeHandle) {
      
          // 当点击的是关闭按钮时，直接跳转详情页
          if (closeHandle.name === 'close') {
            if (!bestSkuSysNo) {
              message.warning('数据异常：当前商品无商品编号');
              return;
            }
            goToProductDetail(bestSkuSysNo, currentProductId as string);
            closeHandle();
          }
     
        },
      });
    }
  };

  return {
    currentSelectedRecommendProduct,
    onRecommendProductClick,
  };
}
